export type RegionChipStyle = {
  backgroundColor: string;
  color: string;
};

const REGION_STYLES: Record<string, RegionChipStyle> = {
  NORTHEAST: { backgroundColor: "#E3F2FD", color: "#1565C0" },
  MIDWEST: { backgroundColor: "#FFF8E1", color: "#F57F17" },
  INTERNATIONAL: { backgroundColor: "#E0F2F1", color: "#00695C" },
  WEST: { backgroundColor: "#F3E5F5", color: "#7B1FA2" },
  SOUTHEAST: { backgroundColor: "#FCE4EC", color: "#C2185B" },
  SOUTH: { backgroundColor: "#FCE4EC", color: "#C2185B" },
};

const DEFAULT_REGION_STYLE: RegionChipStyle = { backgroundColor: "#F5F5F5", color: "#616161" };

export function getRegionChipStyle(region: string): RegionChipStyle {
  return REGION_STYLES[region.toUpperCase()] ?? DEFAULT_REGION_STYLE;
}

export function formatRequestedDate(dateStr: string): string {
  if (!dateStr) {
    return "Date TBD";
  }

  const date = new Date(`${dateStr}T00:00:00`);
  return date.toLocaleDateString("en-US", { month: "long", day: "numeric" });
}

const STATE_TO_REGION: Record<string, string> = {
  CT: "NORTHEAST",
  ME: "NORTHEAST",
  MA: "NORTHEAST",
  NH: "NORTHEAST",
  RI: "NORTHEAST",
  VT: "NORTHEAST",
  NJ: "NORTHEAST",
  NY: "NORTHEAST",
  PA: "NORTHEAST",
  IL: "MIDWEST",
  IN: "MIDWEST",
  MI: "MIDWEST",
  OH: "MIDWEST",
  WI: "MIDWEST",
  IA: "MIDWEST",
  KS: "MIDWEST",
  MN: "MIDWEST",
  MO: "MIDWEST",
  NE: "MIDWEST",
  ND: "MIDWEST",
  SD: "MIDWEST",
  DE: "SOUTHEAST",
  FL: "SOUTHEAST",
  GA: "SOUTHEAST",
  MD: "SOUTHEAST",
  NC: "SOUTHEAST",
  SC: "SOUTHEAST",
  VA: "SOUTHEAST",
  WV: "SOUTHEAST",
  AL: "SOUTH",
  KY: "SOUTH",
  MS: "SOUTH",
  TN: "SOUTH",
  AR: "SOUTH",
  LA: "SOUTH",
  OK: "SOUTH",
  TX: "SOUTH",
  AK: "WEST",
  AZ: "WEST",
  CA: "WEST",
  CO: "WEST",
  HI: "WEST",
  ID: "WEST",
  MT: "WEST",
  NV: "WEST",
  NM: "WEST",
  OR: "WEST",
  UT: "WEST",
  WA: "WEST",
  WY: "WEST",
};

export function getRegionFromLocation(location?: { state?: string; country?: string }): string {
  const country = location?.country?.trim().toUpperCase();
  if (country && country !== "US" && country !== "USA" && country !== "UNITED STATES") {
    return "INTERNATIONAL";
  }

  const stateCode = location?.state?.trim().toUpperCase();
  if (!stateCode) {
    return "UNKNOWN";
  }

  return STATE_TO_REGION[stateCode] ?? stateCode;
}
